import { createSelector } from '@reduxjs/toolkit';

import { CompPropertyDataState, SubjectPropertyDataState } from '../../../types.ts';
import { selectPropertyDataEntities } from './propertyDataSelectors.ts';

export const selectBackupListingDataEntities = createSelector(
  [selectPropertyDataEntities],
  (propertyDataEntities) => {
    const entities =  Object.fromEntries(
      Object.entries(propertyDataEntities).map(([id, propertyDataEntity]) => {
        const propertyData =
          id === 'subject'
            ? (propertyDataEntity as SubjectPropertyDataState).subjectData
            : (propertyDataEntity as CompPropertyDataState).compData;

        const listing = propertyData.readonlyData.backupListingData?.listing;
        return [id, listing ? { id, ...listing } : undefined];
      }),
    );

    if ((propertyDataEntities.subject as SubjectPropertyDataState)?.subjectData?.editableData?.arv) {
      entities.subjectArv = { id: 'subjectArv', ...entities.subject };
    }

    return entities;
  },
);

export const selectBackupListingDataById = createSelector(
  [selectBackupListingDataEntities, (_state, id: string) => id],
  (backupListingDataEntities, id) => backupListingDataEntities[id],
);

export const selectAllBackupListingData = createSelector(
  [selectBackupListingDataEntities],
  (backupListingDataEntities) => Object.values(backupListingDataEntities),
);
